// extracted by mini-css-extract-plugin
module.exports = {"label":"TargetUserSearchFilterLayout_label__24_Ms","fullName":"TargetUserSearchFilterLayout_fullName__FizR4","closeIcon":"TargetUserSearchFilterLayout_closeIcon__3y2MJ"};